import { render, staticRenderFns } from "./EmployeeIssueList.vue?vue&type=template&id=165c4252&scoped=true&"
import script from "./EmployeeIssueList.vue?vue&type=script&setup=true&lang=js&"
export * from "./EmployeeIssueList.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./EmployeeIssueList.vue?vue&type=style&index=0&id=165c4252&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "165c4252",
  null
  
)

export default component.exports